import React from 'react'
import { BaseView } from '@/components/base'
import { AppIcons } from '@/components/AppIcons'
import { useDeviceShare } from '@/hooks/useDeviceShare'
import { useTheme } from '@/hooks/useTheme'

interface CopyProps {
  copyValue: string
  toastMessage: string
  iconColor?: string
  iconSize?: number
  containerSize?: number
}

export const Copy: React.FC<CopyProps> = ({
  copyValue,
  toastMessage,
  iconColor,
  iconSize = 18,
  containerSize = 22,
}) => {
  const { copy } = useDeviceShare()
  const theme = useTheme()

  const handleCopy = () => {
    copy(copyValue, toastMessage)
  }

  return (
    <BaseView
      style={{
        width: containerSize,
        height: containerSize,
        borderRadius: containerSize / 2,
        backgroundColor: theme.colors.background.secondaryGray + '40',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={handleCopy}
    >
      <AppIcons name="copy" size={iconSize} color={iconColor || '#FCFCFC'} />
    </BaseView>
  )
}
